const LOADER_PREFIX = '@LOADER';

export const SHOW = `${LOADER_PREFIX}/SHOW`;
export const HIDE = `${LOADER_PREFIX}/HIDE`;
